import React, { useCallback, useMemo } from "react";

import { cancellationTableColumnsConfig } from "./cancellationTableColumnsConfig";
import { Table } from "../../../component/table/Table";
import { useNavigate } from "react-router-dom";
import { selectCancellationState } from "../../../store/cancellation/cancellationFilterSlice";
import {
  selectCancellations,
  useGetCancellationsListQuery,
} from "../../../services/cancellation/cancellationApiSlice";
import { useSelector } from "react-redux";
import { CategoryPageSkeleton } from "../../../component/skeleton/CategoryPageSkeleton";

export const CancellationTablePage = () => {
  const navigate = useNavigate();
  const appliedFilters = useSelector(selectCancellationState);
  const { isLoading, isFetching } = useGetCancellationsListQuery(
    appliedFilters,
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const tableData = useSelector(selectCancellations);

  const handleOpenModal = useCallback((rowData, action) => {
    // Implement your modal logic here
    console.log("Row Data: ", rowData, "Action: ", action);
  }, []);

  const handleCancellationDetail = useCallback(
    (cancelltionId) => {
      // dispatch(setOrderId({ order_id: rowId }));
      console.log("details", cancelltionId);
      navigate(`/cancelled_orders/${cancelltionId}`);
    },
    [navigate],
  );

  const columnDefs = useMemo(
    () =>
      cancellationTableColumnsConfig(handleOpenModal, handleCancellationDetail),
    [handleOpenModal, handleCancellationDetail],
  );

  if (isLoading && tableData.length === 0) {
    return <CategoryPageSkeleton />;
  }

  return (
    <Table
      data={tableData}
      columns={columnDefs}
      loading={isLoading}
      isFetching={isFetching}
    />
  );
};
